import React, { useEffect } from 'react';
import styles from './styles.module.scss';
import { useLocalStorage } from 'hooks/useLocalStorage';

type Plan = '@1-week plan' | '@1-month plan' | '@3-month plan';

const names = [
  'Emma',
  'Daniel',
  'Sophia',
  'Joseph',
  'Harper',
  'David',
  'Andrew',
  'Eleanor',
  'Elizabeth',
  'Olivia',
  'Matthew',
  'Robert',
  'Anthony',
  'Evelyn',
  'Joshua',
  'Ava',
  'Mia',
  'Charles',
  'William',
  'Scarlett',
  'Christopher',
  'Donald',
  'Ella',
  'Amelia',
  'John',
  'Steven',
  'Charlotte',
  'Luna',
  'Paul',
  'Richard',
  'Gianna',
  'Thomas',
  'Avery',
  'Michael',
  'Abigail',
  'Emily',
  'Mark',
  'Isabella',
  'Sofia',
  'Jacob',
];

const plans: Plan[] = ['@1-week plan', '@1-month plan', '@3-month plan'];

const getRandomInt = (min: number, max: number): number =>
  Math.floor(Math.random() * (max - min + 1)) + min;

const generateEmail = (): string => {
  const name = names[getRandomInt(0, names.length - 1)];
  const plan = plans[getRandomInt(0, plans.length - 1)];
  return `${name.slice(0, 4)}***${plan}`;
};

const generateEmails = (count = 7): string[] =>
  Array.from({ length: count }, generateEmail);

export const ActivationBanner: React.FC = () => {
  const [userCount, setUserCount] = useLocalStorage<number | null>(
    'loona_userCount',
    null,
  );
  const [emails, setEmails] = useLocalStorage<string[] | null>(
    'loona_emails',
    null,
  );

  useEffect(() => {
    if (userCount === null) {
      setUserCount(getRandomInt(150, 300));
    }

    if (!emails || emails.length === 0) {
      setEmails(generateEmails(getRandomInt(5, 7)));
    }
  }, [userCount, emails, setUserCount, setEmails]);

  return (
    <div className={styles.container}>
      <h2 className={styles.title}>
        {userCount ?? '...'} people bought our plans in the last hour
      </h2>
      <div className={styles.marquee}>
        <div className={styles.emailList}>
          {[...(emails ?? []), ...(emails ?? [])].map((email, idx) => (
            <span key={idx} className={styles.emailChip}>
              {email}
            </span>
          ))}
        </div>
      </div>
    </div>
  );
};
